<template>
    <div>
        <el-table :data="records" style="width: 100%" fit class="compact-table" :header-cell-class-name="getCompactClassName" :cell-class-name="getCompactClassName" :row-class-name="getRowClassName">
            <el-table-column :label="$t('agent-console.status')" class-name="td-icon" sortable :sort-method="sortNumber" width="100">
                <template slot-scope="scope">
                    <i :class="callTypeClassName(scope.row)"></i>
                    <i class="fas fa-coffee" v-if="scope.row.in_break"></i>
                </template>
            </el-table-column>
            <el-table-column prop="name" :label="$t('agent-console.agent')" sortable class-name="td-ellipsis" />
            <el-table-column prop="number" width="110" :label="$t('agent-console.number')" sortable align="center" />
            <el-table-column :label="$t('agent-console.call')" width="85" align="center">
                <template slot-scope="scope">
                    <i class="fas fa-check-circle" v-if="scope.row.call_logged"></i>
                    <i class="fas fa-times" v-else></i>
                </template>
            </el-table-column>
            <el-table-column :label="$t('agent-console.chat.chat')" width="70" align="center">
                <template slot-scope="scope">
                    <i class="fas fa-check-circle" v-if="scope.row.chat_logged"></i>
                    <i class="fas fa-times" v-else></i>
                </template>
            </el-table-column>
            <el-table-column prop="calls_total.incoming" width="90" :label="$t('agent-console.calls_total.incoming')" align="center" />
            <el-table-column prop="calls_total.manual" width="90" :label="$t('agent-console.calls_total.manual')" align="center" />
            <el-table-column prop="calls_total.failed" width="90" :label="$t('agent-console.calls_total.failed')" align="center" />
            <el-table-column :label="$t('agent-console.logged_started_at')" width="110">
                <template slot-scope="scope">
                    <Chronometer style="display: inline-block;" :timestamp="scope.row.logged_started_at" />
                </template>
            </el-table-column>
			<el-table-column prop="break_name" :label="$t('agent-console.break_name')" />
			<el-table-column :label="$t('agent-console.break_started_at')" width="120">
                <template slot-scope="scope">
                    <Chronometer style="display: inline-block;" :timestamp="scope.row.break_started_at" v-if="scope.row.in_break"/>
                </template>
            </el-table-column>
            <el-table-column width="60">
                <template slot-scope="scope">
                    <!-- <SpyWhisper v-if="spy_whisper" :agent_number="scope.row.extension" :compact="true" ref="sw"></SpyWhisper> -->
                    <TheDropdownAgentCard :agent="scope.row"></TheDropdownAgentCard>
                </template>
            </el-table-column>
        </el-table>
    </div>
</template>

<script>
import Chronometer from "@/components/common/Chronometer";
import TheDropdownAgentCard from "@/components/dashboard/TheDropdownAgentCard";
import { mapGetters } from 'vuex';

export default {
  name: "TheAgentTableRow",
  data( ){
    return {
        types: {
            spy: 551,
            whisper: 553
        }
    }
  },
  props: {

    ellipsis:{
        required: false,
        default: false
    },
    stats:{
        required: false,
        default: false
    },
    spy_whisper:{
        required: false,
        default: false
    },
    records:{
        required: true
    }
  },
  methods: {
    getCompactClassName( ){
        return 'compact';
    },
    sortNumber( a, b ){
        const nA = ( a.call_type || a.call_status ) == 'idle' ? 1 : 0;
        const nB = ( b.call_type || a.call_status ) == 'idle' ? 1 : 0;

        return nA < nB ? -1 : ( nA > nB ? 1: 0);
    },
    getRowClassName( { row } ){
        if( this.isSupervised(row) ) return 'row-shadow-active';
        return '';
    }
  },
  computed:{
    ...mapGetters({ getIsInCallWith : 'getIsInCallWith' }),
    isSupervised(){
        const vm = this;
        return function( agent ){
            if(vm.getIsInCallWith){
                if( vm.types.spy && vm.getIsInCallWith ==  `*${vm.types.spy}${agent.extension}` ) return true;
                if( vm.types.whisper && vm.getIsInCallWith == `*${vm.types.whisper}${agent.extension}` ) return true;
            }
            return false;
        }
    },
    styleName(){
        return "mb-0" + ( this.ellipsis ? ' ellipsis': '' );
    },
    callTypeClassName( ){
        return function( agent ){ 
            if (!agent.call_type) { return "fas fa-headset"; }
            return 'fas hm-icon hm-' + agent.call_type;
        }
    },
  },
  components: {
    Chronometer,
    TheDropdownAgentCard
  }
};
</script>
<style>


</style>
<style scoped>
div >>> .compact-table{
    --font-size: 0.69rem;
    --icon-size: calc( var(--font-size) * 1.3 );
    margin-top: 1rem;
}

div >>> .compact-table th.compact,
div >>> .compact-table td.compact{
    padding: 1px 10px;
    vertical-align: middle;
}

div >>> .compact-table th.compact,
div >>> .compact-table td.compact,
div >>> .compact-table td.compact *{
    font-size: var(--font-size);
}

div >>> .compact-table td.td-ellipsis div{
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}


div >>> td.td-icon{
    width: var(--icon-size);
    padding: 1px;
}

div >>> .fa-times{
    color: var(--grey-status);
}

div >>> .fa-coffee {
    color: var(--red);
    margin-left: .64em;
}

div >>> .fa-check-circle,
div >>> .fa-phone,
div >>> .logged {
    color: var(--green);
}

div >>> .fas {
   font-size: var(--icon-size);
}

div >>> .hm-icon::before{
    content: "";
    display: inline-block;
    height: var(--icon-size);
    width: var(--icon-size);
    background-size: contain;
}

div >>> .hm-outgoing::before{
    background-image: url('data:image/svg+xml;base64,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');
}

div >>> .hm-incoming::before{
    background-image: url('data:image/svg+xml;base64,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');
}

div >>> .fa-headset {
    color: var(--other-blue);
}

div >>> .row-shadow-active td,
div >>> .row-shadow-active:hover td{
    background-color: rgb(116 246 101 / 19%) !important
}

div >>> .row-shadow-active td .fa-times{
    color: var(--blue-grey);
}

div >>> tr:nth-child(odd){
    background: #ededed;
}
div >>> tr:hover td{
    transition: none !important;
    background: #e1e1e1 !important;
}

</style>